interface RequirementItemProps {
    met: boolean
    children: React.ReactNode
}


/**
 * Displays password requirement with visual check/cross indicator.
 * Provides real-time feedback during password creation.
 */

export function RequirementItem({ met, children }: RequirementItemProps) {

  return (
    <div className="flex items-center gap-2 text-sm">
      <div className={`flex-shrink-0 w-5 h-5 rounded-full flex items-center justify-center ${
        met ? 'bg-green-100' : 'bg-gray-100'
      }`}>
        {met ? (
          <svg className="w-3 h-3 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
          </svg>
        ) : (
          <svg className="w-3 h-3 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        )}
      </div>
      <span className={met ? 'text-green-400 font-medium' : 'text-gray-300'}>
        {children}
      </span>
    </div>
  )
}
